module.exports = "/templates/samllogin.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/samllogin.html
// module id = 458
// module chunks = 0